import { AlertService } from '@app/services/alert.service';
import { Component, OnInit, Input } from '@angular/core';
import { BeneficiaryService } from '@app/services/admin/beneficiary.service';
import { BeneficiaryType } from '@app/enums/BeneficiaryType';

@Component({
  selector: 'app-beneficiary-logs-insert-segment',
  templateUrl: './beneficiary-logs-insert-segment.component.html',
  styleUrls: ['./beneficiary-logs-insert-segment.component.scss']
})
export class BeneficiaryLogsInsertSegmentComponent implements OnInit {
  _data;
  isOpen = false;
  @Input() public data: any;
  beneficiaryName : any;
  beneficiaryType : BeneficiaryType;

  constructor(private beneficiaryService: BeneficiaryService,
              private alertService: AlertService) { }

  ngOnInit() {
    this.beneficiaryType = this.data.Table =="InvestorAssetManagerLookup" ? BeneficiaryType.AssetManager : 
                           this.data.Table == "InvestorFundLookup" ? BeneficiaryType.Fund :
                           this.data.Table == "InvestorBeneficiary"? BeneficiaryType.DecisionMaker : BeneficiaryType.AssetManager;
    this.beneficiaryService.getBeneficiary(this.data.PrimaryKey.Id, this.beneficiaryType)
                            .subscribe(b=> { this.beneficiaryName = b.name},
                            err => {
                              this.alertService.sendError(err.error);
                            });
    const values = this.data.ColumnValues;
    this._data = Object.keys(values).map(key => {
      return {
        value: values[key]?  values[key] : 'Empty',
      };
    });
  }
}
